export function createHttpsUrl(url: string): string {
  try {
    // eslint-disable-next-line no-new
    new URL(url);
  } catch (_) {
    return 'https://' + url;
  }
  return url;
}
